import { useCallback } from 'react';

import { ConditionsReactivateFooterLinkDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import { useActivationFooterLinkReturn } from '../types';

export function useActivationFooterLink(): useActivationFooterLinkReturn {
  const controller = useApi().AdminFonctionnelControllerApi;

  const submitDeprecate = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.deprecateFooterLinkUsingPUT(idCorrelation);
    },
    [controller],
  );

  const submitReactivate = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.reactivateFooterLinkUsingPUT(idCorrelation);
    },
    [controller],
  );

  const conditionsReactivate = useCallback(
    (idCorrelation: string): Promise<ConditionsReactivateFooterLinkDto> => {
      return controller.conditionReactivationFooterLinkUsingGET(idCorrelation);
    },
    [controller],
  );

  return {
    submitReactivate,
    submitDeprecate,
    conditionsReactivate,
  };
}
